module.exports = __webpack_public_path__ + "static/fonts/iconfont.f84e9914.woff";